@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../styles/Colors.scss' as Colors;

$var-shadow: 0 1px 4px 0 Colors.$col-shadow;

.form {
	background: Colors.$col-white;
	border-radius: Constants.$val-borderRadius;
	-webkit-box-shadow: $var-shadow;
	box-shadow: $var-shadow;
	margin-bottom: Constants.$val-spacing-l;
	border: 1px solid Colors.$col-shadow;
	width: 100%;
}